import React, { FC, useEffect, useState } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { useDocumentsQuery } from '../../api';
import { DocumentsFilter } from '../../components/Filters';
import { Grid, Tooltip } from '@material-ui/core';
import TABLE_OPTIONS from '../../config/tables';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import moment from 'moment';

const PER_PAGE = 10;

const Page: FC<{}> = () => {
  const [page, setPage] = useState<number>(0);
  const [filter, setFilter] = useState<any>({
    archive: null,
  });
  const [documents, setDocuments] = useState<any>([]);
  const { push } = useHistory();
  const access = usePermission('directory', 'classifiers');
  const { data } = useDocumentsQuery({ variables: { skip: page, first: PER_PAGE, filter }, fetchPolicy: 'no-cache' });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'info',
      label: 'Название документа',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (info) => {
          const { id, title } = info || {};
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/document/${id}`}
                >
                  {title}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'date',
      label: 'Дата',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (date) => <React.Fragment>{moment(date).format('DD.MM.YYYY')}</React.Fragment>,
      },
    },
    {
      name: 'number',
      label: 'Номер',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  useEffect(() => {
    setDocuments(
      data?.dirDocuments?.map(({ id, title, ...otherProps }) => ({ info: { id, title }, ...otherProps })) || [],
    );
  }, [page, data]);

  return (
    <MainTemplate pageName="Документов" url="">
      <DocumentsFilter onSubmit={(filter: any) => setFilter(filter)} />
      <DictionaryWrapper>
        <MUIDataTable
          title={
            <React.Fragment>
              <h2>Справочник Документов</h2>
              <Grid container spacing={1}>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/document/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          data={documents || []}
          columns={columns}
          options={{
            ...TABLE_OPTIONS,
            onTableChange: (action, tableState) => {
              switch (action) {
                case 'changePage':
                  setPage(tableState.page);
                  break;
              }
            },
            rowsPerPage: PER_PAGE,
            count: data && data.count,
            page,
          }}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
